import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  minWidth: (p) => p.spacing(50),
  maxWidth: (p) => p.spacing(60),
};

export const name: SxStyle = {
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption,
  color: (p) => p.palette.grey[500],
};
